module.exports = __webpack_public_path__ + "img/yipei.e45530c0.png";